export default "__VITE_PUBLIC_ASSET__5b7758e0__"